import { render } from "./informationMatch.vue?vue&type=template&id=7c5715b8&scoped=true"
import script from "./informationMatch.vue?vue&type=script&lang=js"
export * from "./informationMatch.vue?vue&type=script&lang=js"

import "./informationMatch.vue?vue&type=style&index=0&id=7c5715b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5715b8"]])

export default __exports__